import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';

const useToursListingCMSData = () => {
  const { t } = useTranslation();

  const data = useMemo(
    () => ({
      data: {
        ToursListingPage: {
          motorcycleToursLabel: t('tours_listing:all_motorcycle_tours'),
          subtitleAllmotorcycleToursLabel: t(
            'tours_listing:subtitle_all_motorcycle_tours',
          ),
          allToursLabel: t('tours_listing:all_motorcycle_tours'),
          guidedToursLabel: t('tours_listing:guided_tours'),
          selfGuidedToursLabel: t('tours_listing:self_guided_tours'),
          guidedMotorcycleToursLabel: t('tours_listing:guided_motorcycle_tours'),
          selfGuidedMotorcycleToursLabel: t(
            'tours_listing:self_guided_motorcycle_tours',
          ),
          pageSubTitle: t('tours_listing:page_subtitle'),
          pageTitleWithFilter: t('tours_listing:page_Title_with_filter'),
          pageSubTitleWithFilter: t('tours_listing:page_Sub_Title_with_filter'),
          headingDescription: t('tours_listing:heading_description'),
          pricingTermsLabel: t('tours_listing:pricing_terms_label'),
          searchAction: t('tours_listing:search'),
          viewResultsBtnLabel: t('tours_listing:view_results'),
          filterBtnLabel: t('tours_listing:filter'),
          searchToursOverlatTitle: t('tours_listing:search_tours'),
          searchTourNameLabel: t('tours_listing:search_tour_name'),

          // Filter default labels
          allTourTypesLabel: t('tours_listing:all_tour_types'),
          allCountriesLabel: t('tours_listing:all_countries'),
          allStatesLabel: t('tours_listing:all_states'),
          anyDurationLabel: t('tours_listing:any_duration'),
          durationsList: [
              { id: 1, from: 0, to: Infinity, name: t('tours_listing:any_duration') },
              { id: 2, from: 2, to: 5, name: t('tours_listing:from_two_to_five') },
              { id: 3, from: 6, to: 10, name: t('tours_listing:from_six_to_ten') },
              { id: 4, from: 11, to: Infinity, name: t('tours_listing:up_eleven') },
            ],
          noToursAvailable: t('tours_listing:no_tours_available'),
          noToursAvailableDescription: t('tours_listing:no_tours_available_description'),
        },
        PricingTermsOverlayComponent: {
          pricingTermsHeading: t('common_pricing_terms_overlay:pricing_terms'),
          pricingTermsDescription: t('common_pricing_terms_overlay:pricing_terms_text'),
        },
        TourCardComponent: {
          dayCount: t('common_tour_card:days'),
          miCount: t('common_tour_card:mi'),
          startingAt: t('common_tour_card:start_at'),
          kmCount: t('common_tour_card:km'),
          pricingTermsLabel: t('common_tour_card:pricing_terms_label'),
        },
      },
    }),
    [t],
  );

  return data;
};

export { useToursListingCMSData };
